// タブ
jQuery(function ($) {
  jQuery(function ($) {
    if ($(".js-faq-tab").length > 0) {
      $(".js-tab-item").on("click", function () {
        $(".js-tab-item").removeClass("is-active");
        $(this).addClass("is-active");
        $(".js-tab-content").removeClass("is-active");
        $(".js-tab-content").eq($(this).index()).addClass("is-active");
      });
    }
  });
});

// アコーディオンの起動 // Activate the accordion
jQuery(function ($) {
  if ($(".accordion").length > 0) {
    $(".accordion .toggle").click(function () {
      $(this).next(".contents").slideToggle();
      $(this).toggleClass("open");
    });
  }
});


// // js-fixedCta
// jQuery(function ($) {
//   var $fixedCta = $(".js-fixedCta");
//   var $fv = $(".p-fv");

//   if ($fixedCta.length === 0 || $fv.length === 0) {
//     return;
//   }

//   $fixedCta.hide();

//   var isVisible = false;

//   function toggleFixedCta() {
//     var triggerPoint = $fv.offset().top + $fv.outerHeight() - 300;
//     var shouldShow = $(window).scrollTop() > triggerPoint;

//     if (shouldShow && !isVisible) {
//       $fixedCta.stop(true, true).fadeIn(300);
//       isVisible = true;
//     } else if (!shouldShow && isVisible) {
//       $fixedCta.stop(true, true).fadeOut(300);
//       isVisible = false;
//     }
//   }

//   toggleFixedCta();
//   $(window).on("scroll resize", toggleFixedCta);
// });